// Accordéon « Réduction » du panier déroulant (snippets/cart-drawer-discount.liquid).
// Fichier à part, chargé par cart-drawer.liquid sur toutes les pages : le bloc peut apparaître après un ajout au
// panier sans rechargement, et un script {% javascript %} du snippet ne serait alors pas chargé.
(() => {
  if (window.__cartDrawerDiscountAccordion) return;
  window.__cartDrawerDiscountAccordion = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const open = (details) => {
    details.open = true;
    // Laisse le navigateur peindre l'état replié avant de lancer l'ouverture.
    requestAnimationFrame(() => requestAnimationFrame(() => details.classList.add('is-open')));
  };

  const close = (details) => {
    const panel = details.querySelector('.cart-drawer-discount__panel');
    details.classList.remove('is-open');
    if (reduceMotion.matches || !panel) {
      details.open = false;
      return;
    }
    const done = (e) => {
      if (e && e.target !== panel) return;
      panel.removeEventListener('transitionend', done);
      clearTimeout(fallback);
      if (!details.classList.contains('is-open')) details.open = false;
    };
    const fallback = setTimeout(done, 400);
    panel.addEventListener('transitionend', done);
  };

  document.addEventListener('click', (event) => {
    const summary = event.target instanceof Element && event.target.closest('.cart-drawer-discount__summary');
    if (!summary) return;
    const details = summary.parentElement;
    if (!(details instanceof HTMLDetailsElement)) return;

    event.preventDefault();
    if (details.classList.contains('is-open')) close(details);
    else open(details);
  });

  // Après « Appliquer » : on referme si le code est accepté ; s'il est refusé, cart-discount.js affiche
  // l'erreur avant de résoudre sa promesse, et le bloc reste ouvert. Le retrait d'un code ne referme rien :
  // un ajout envoie un code de plus que les pastilles affichées, un retrait un de moins.
  document.addEventListener('shopify:cart:discount-update', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const block = target && target.closest('.cart-drawer-discount');
    if (!block || !event.promise || !Array.isArray(event.discountCodes)) return;
    if (event.discountCodes.length <= block.querySelectorAll('.cart-discount__pill').length) return;
    event.promise
      .then(() => {
        requestAnimationFrame(() => {
          const details = document.querySelector('.cart-drawer-discount');
          const error = details && details.querySelector('.cart-drawer-discount__error');
          if (details && details.classList.contains('is-open') && error && error.classList.contains('hidden')) {
            close(details);
          }
        });
      })
      .catch(() => {});
  });
})();
